import React, { ChangeEvent, useCallback, useEffect, useState } from 'react'
import './select.sass'

export const Select = ({ list, onChange, className = '' }: { list: Array<{ id: string, title: string }>, onChange: (value: string | null) => void, className?: string }) => {
    const [value, setValue] = useState<string | null>(null)
    const cb = useCallback((ev: ChangeEvent<HTMLSelectElement>) => {
        setValue(ev.target.value);
    }, [])

    useEffect(() => {
        onChange(value)
    }, [value])

    return (
        <div className={`select-component ${className}`}>
            <div>
                <select onChange={cb}>
                    {
                        list.map(i => (
                            <option key={i.id} id={i.id} value={i.id} >
                                {i.title}
                            </option>
                        ))
                    }
                </select>
                <span className="material-icons">arrow_drop_down</span>
            </div>
        </div>
    )
}